export const CarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      {...props}
    >
      <path d="M14.1665 16.6667V17.3334C14.1665 17.8857 14.6142 18.3334 15.1665 18.3334H16.4998C17.0521 18.3334 17.4998 17.8857 17.4998 17.3334V16.6667" />
      <path
        d="M0.833496 8.33333H1.84077C2.2408 8.33333 2.60233 8.09494 2.75991 7.72725L4.74042 3.10608C4.898 2.7384 5.25954 2.5 5.65957 2.5H14.3408C14.7408 2.5 15.1023 2.7384 15.2599 3.10608L17.2404 7.72725C17.398 8.09494 17.7595 8.33333 18.1596 8.33333H19.1668V15H0.833504L0.833496 8.33333Z"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 16.6667V17.3334C2.5 17.8857 2.94771 18.3334 3.5 18.3334H4.83333C5.38562 18.3334 5.83333 17.8857 5.83333 17.3334V16.6667"
        strokeWidth="1.67"
      />
      <path d="M2.5 8.33325H14.1667" strokeLinecap="round" />
      <path d="M4.1665 11.25L4.1665 12.0833" strokeLinecap="round" />
      <path d="M15.8335 11.25L15.8335 12.0833" strokeLinecap="round" />
    </svg>
  );
};
